import { IdealBankElement } from '@stripe/react-stripe-js'
import React from 'react'
import idealElementOptions from './constants/idealElementOptions'

function IDeal() {
  return <IdealBankElement className="Ideal" options={idealElementOptions} />
}

export default IDeal
